import * as React from 'react';
// @ts-expect-error
import type {NetworkStatus} from 'react-apollo';

import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetDripSequenceEditions as GetDripSequenceEditionsQuery,
    GetDripSequenceEditionsVariables as GetDripSequenceEditionsQueryVariables,
    EditionFragment as Edition,
} from 'nutshell-graphql-types';

import {getDripSequenceEditionStubsQueryVariables} from '../helpers';

import GET_EDITIONS from './graphql/queries/get-drip-sequence-editions.graphql';

type Props = {
    dripSequenceId: string;
    skip?: boolean;
    isArchived?: boolean;
    children: (arg1: {
        editions: Edition[];
        error: string | null | undefined;
        isLoading: boolean;
        refetch: () => Promise<any>;
        networkStatus: NetworkStatus;
    }) => React.ReactElement;
};

export function DripSequenceEditionsQuery(props: Props) {
    const variables = getDripSequenceEditionStubsQueryVariables(
        props.dripSequenceId,
        props.isArchived
    );

    const {
        data,
        loading: isLoading,
        error,
        refetch,
        networkStatus,
    } = useQuery<GetDripSequenceEditionsQuery, GetDripSequenceEditionsQueryVariables>(
        GET_EDITIONS,
        {
            skip: props.skip,
            variables: variables,
            fetchPolicy: 'cache-and-network',
            notifyOnNetworkStatusChange: true,
        }
    );

    const editionsData = data && data.dripSequence ? data.dripSequence.editions : null;

    const editions = editionsData
        ? editionsData.edges.map((edition) => {
              return edition.node;
          })
        : [];

    return props.children({
        editions,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
        refetch,
        networkStatus,
    });
}
